import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface AsaasTabProps {
  integration: Integration | null;
}

function AsaasTab({ integration }: AsaasTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="asaas_url">URL Asaas</FormLabel>
        <FormInput id="asaas_url" name="asaas_url" defaultValue={integration?.asaas_url} />
      </FormField>

      <FormField>
        <FormLabel htmlFor="asaas_access_token">Access Token</FormLabel>
        <FormInput
          type="password"
          id="asaas_access_token"
          name="asaas_access_token"
          defaultValue={integration?.asaas_access_token}
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="asaas_evp_key">EVP Key</FormLabel>
        <FormInput id="asaas_evp_key" name="asaas_evp_key" defaultValue={integration?.asaas_evp_key} />
      </FormField>
    </div>
  );
}

export default AsaasTab;
